// extracted by mini-css-extract-plugin
export default {"PaginationResults":"pagination-results_PaginationResults__ncqr8","highlight":"pagination-results_highlight__jUNpL"};